import { parseBoolean } from '@tunein/web-utils';
import { toHttps } from '../../../transforms/utils';
import { injectShoutcastStreams, transformMislabelledHlsStreams } from '../';
import { mediaFormats } from '../constants';
import { getMediaFormat, isSubscriptionRequiredStream } from '../utils';
const DEFAULT_STREAM_TIMEOUT = 15000;
function mapStreams(tuneInPlaylistHandler, forceHttpsStreams) {
    return (stream) => {
        const { url: rawUrl, reliability, mediaType, playlistType, guideId, nextGuideId, itemToken, position, isProxy, liveSeekStream, isHlsAdvanced, useStreamMetadata, isAdClippedContentEnabled, rejectReason, isBoostStation: isBoostStream, isPreroll, bitrate, } = stream;
        const isTuneInPlaylistFormat = parseBoolean(isProxy);
        const url = forceHttpsStreams ? toHttps(rawUrl) : rawUrl;
        const transformedStream = {
            url,
            reliability,
            format: isTuneInPlaylistFormat
                ? mediaFormats.tipls
                : getMediaFormat(playlistType, mediaType),
            id: guideId,
            nextGuideId,
            itemToken,
            bitrate,
            position: Number(position) || 0,
            isLiveSeekStream: parseBoolean(liveSeekStream),
            isHlsAdvanced: parseBoolean(isHlsAdvanced),
            isSSAI: parseBoolean(isHlsAdvanced),
            useStreamMetadata: parseBoolean(useStreamMetadata),
            isMidrollEnabled: parseBoolean(isAdClippedContentEnabled),
            isBoostStream: parseBoolean(isBoostStream),
            isPrerollStream: parseBoolean(isPreroll),
            isSubscriptionRequiredStream: isSubscriptionRequiredStream(stream),
            timeout: DEFAULT_STREAM_TIMEOUT,
            rejectReason,
            wasManuallyUpgradedToHttps: Boolean(forceHttpsStreams && rawUrl?.startsWith('http://')),
        };
        if (isTuneInPlaylistFormat) {
            transformedStream.playlistHandler = () => tuneInPlaylistHandler(url);
        }
        return transformedStream;
    };
}
function splitStandaloneStreams(boostStreamMetadata) {
    return (streams, stream) => {
        if (stream.isPrerollStream) {
            streams.prerollStream = stream;
        }
        else if (stream.isBoostStream) {
            streams.boostStream = {
                ...stream,
                ...boostStreamMetadata,
            };
        }
        else if (stream.isSubscriptionRequiredStream) {
            streams.subscriptionRequiredStream = stream;
        }
        else {
            streams.streams.push(stream);
        }
        return streams;
    };
}
export function transformTuneStreams({ streams, tuneInPlaylistHandler, boostStreamMetadata, forceHttpsStreams, }) {
    const streamsAfterShoutcastInjection = [];
    const finalStreams = { streams: [] };
    return (streams
        .map(mapStreams(tuneInPlaylistHandler, forceHttpsStreams))
        .map(transformMislabelledHlsStreams)
        .reduce(injectShoutcastStreams, streamsAfterShoutcastInjection)
        .reduce(splitStandaloneStreams(boostStreamMetadata), finalStreams));
}
